"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pick = void 0;

var _operators = require("rxjs/operators");
/** rxjs extends */


var pick = function pick(key) {
  return function (source) {
    return source.pipe((0, _operators.pluck)(key), (0, _operators.filter)(function (value) {
      return value !== undefined;
    }));
  };
};

exports.pick = pick;